module.exports = __webpack_public_path__ + "static/fonts/lato-light.90301aa.woff";


//////////////////
// WEBPACK FOOTER
// ./node_modules/lato-font/fonts/lato-light/lato-light.woff
// module id = NI8X
// module chunks = 13